import { buildProps, definePropType } from "@xplus/utils/props";
import type { InjectionKey, ExtractPropTypes, VNode } from "vue";
export const popSizes = ["big", "medium", "small", "mini"];
export const popUpProps = buildProps({
  appendToBody: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Boolean,
  },
  title: {
    type: String,
  },
  size: {
    type: String,
    values: popSizes,
    default: "medium",
  },
  to: {
    type: String,
  },
  /** 宽度 */
  width: {
    type: Number,
  },
  /** 是否全屏 */
  fullScreen: { type: Boolean },
  /** 是否显示底部 */
  isFooter: {
    type: Boolean,
    default: false,
  },
  /** 取消按钮文本 */
  cancelButtonText: { type: String },
  /** 确认按钮文本 */
  confirmButtonText: { type: String },
  /** 加载 */
  loading: {
    type: Boolean,
    default: false,
  },
  /** 加载显示文本 */
  loadingText: {
    type: String,
  },
  /** 确认按钮loading */
  confirmLoading: {
    type: Boolean,
    default: false,
  },
  /** padding样式 */
  padding: {
    type: [Number, Array],
    default: 16,
  },
  zIndex: {
    type: Number,
  },
  titleClass: {
    type: String,
  },
  bodyClass: {
    type: String,
  },
  titleExtra: {
    type: definePropType<string | VNode>([String, Object]),
    default: "",
  },
} as const);

export const closePopUpKey: InjectionKey<(val?: any) => void> =
  Symbol("closePopUp");
export type PopUpProps = ExtractPropTypes<typeof popUpProps>;
